import { trans } from '@flexteam/i18n-base';

const RECENT_LIMIT = 20;
const CATEGORY_KEY_MAP = {
  foods: trans("@flex-services/emoji.components/emoji_picker.category.foods"),
  objects: trans(
    "@flex-services/emoji.components/emoji_picker.category.objects"
  ),
  recent: trans("@flex-services/emoji.components/emoji_picker.category.recent"),
  flags: trans("@flex-services/emoji.components/emoji_picker.category.flags"),
  people: trans("@flex-services/emoji.components/emoji_picker.category.people"),
  nature: trans("@flex-services/emoji.components/emoji_picker.category.nature"),
  places: trans("@flex-services/emoji.components/emoji_picker.category.places"),
  activity: trans(
    "@flex-services/emoji.components/emoji_picker.category.activity"
  ),
  symbols: trans(
    "@flex-services/emoji.components/emoji_picker.category.symbols"
  )
};
const EMOJI_JSON_S3_PATH = "/v2/shared/emojis/emojis.json";
var EmojiImageSize = /* @__PURE__ */ ((EmojiImageSize2) => {
  EmojiImageSize2[EmojiImageSize2["Small"] = 64] = "Small";
  EmojiImageSize2[EmojiImageSize2["Large"] = 160] = "Large";
  return EmojiImageSize2;
})(EmojiImageSize || {});

export { CATEGORY_KEY_MAP, EMOJI_JSON_S3_PATH, EmojiImageSize, RECENT_LIMIT };
//# sourceMappingURL=constants.mjs.map
